
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.207 24a.75.75 0 01-.75-.75v-9.5c0-.965.785-1.75 1.75-1.75h7c.965 0 1.75.785 1.75 1.75v8.75h5.246a.75.75 0 010 1.5H7.207zm8.25-1.5v-6h-1.504a.75.75 0 010-1.5h1.504v-1.25a.25.25 0 00-.25-.25h-7a.25.25 0 00-.25.25v8.75H9.45v-2.25c0-1.241 1.009-2.25 2.25-2.25s2.25 1.009 2.25 2.25v2.25h1.507zm-3.007 0v-2.25a.75.75 0 00-1.5 0v2.25h1.5z"}}),_c('path',{attrs:{"d":"M1.203 24a.75.75 0 010-1.5h.747V5.25A2.252 2.252 0 014.2 3h4.5a2.252 2.252 0 012.25 2.25V6.7a.343.343 0 010 .099V9.75a.75.75 0 01-.75.75H8.7a.75.75 0 010-1.5h.75V7.5H7.203a.75.75 0 010-1.5H9.45v-.75a.75.75 0 00-.75-.75H4.2a.75.75 0 00-.75.75V22.5h.75a.75.75 0 010 1.5H1.203zM18.453 9c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zM18.453 2.25a.75.75 0 01-.75-.75V.75a.75.75 0 011.5 0v.75a.75.75 0 01-.75.75zM14.556 4.5a.75.75 0 01-.375-.101l-.649-.375a.75.75 0 11.75-1.298l.649.375a.751.751 0 01-.375 1.399zM13.907 9.375a.751.751 0 01-.375-1.4l.649-.375a.754.754 0 011.025.275.751.751 0 01-.274 1.025l-.649.375a.766.766 0 01-.376.1zM18.453 12a.75.75 0 01-.75-.75v-.75a.75.75 0 011.5 0v.75a.75.75 0 01-.75.75zM22.999 9.375a.763.763 0 01-.375-.1l-.649-.375a.751.751 0 01.75-1.3l.65.375a.751.751 0 01-.376 1.4zM22.35 4.5a.75.75 0 01-.375-1.4l.65-.375a.75.75 0 01.75 1.3l-.65.375a.763.763 0 01-.375.1z"}})])
          )
        }
      }
    